import React, { SetStateAction, useContext, useEffect } from "react";
import { useState } from "react";
import {
    Paper,
    Snackbar,
    Stack,
    TableBody,
    TableFooter,
    TablePagination,
} from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import {
    StyledTableHead,
    StyledTableCell,
} from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { Alert } from "../../../Components/Alert/Alert";
import { INutrientes } from "../../../Interfaces/anexos/anexo1/composicao_adubacao_azoto_nutrientes1_4_7";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { sum_column_from_array } from "../../../Func_genericas/sum_column_from_array";
import { IPlanoNutrientes } from "../../../Interfaces/anexos/anexo1/plano_nutrientes1_3";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";



interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
    set_obj_da_tabela_3_atualizado: React.Dispatch<SetStateAction<IPlanoNutrientes | undefined>>;

}



export const NutrientesForm: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado, set_obj_da_tabela_3_atualizado }) => {
    const auth = useContext(AuthContext);
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [createTable, setCreateTable] = useState(false);
    const [message, setMessage] = useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = useState(false);
    const [openSnackError, setOpenSnackError] = useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [obj_anexo, set_obj_anexo] = useState<INutrientes | undefined>();
    const [obj_anexo_lista, set_obj_anexo_lista] = useState<INutrientes[]>([]);
    const [error_ko_total, set_error_ko_total] = useState<boolean>(false);
    const [error_numero, set_error_numero] = useState<boolean>(false);
    const [error_valor_ref_n, set_error_valor_ref_n] = useState<boolean>(false);
    const [error_valor_ref_po, set_error_valor_ref_po] = useState<boolean>(false);
    const [error_valor_ref_ko, set_error_valor_ref_ko] = useState<boolean>(false);
    const [error_numero_total, set_error_numero_total] = useState<boolean>(false);
    const [error_po_total, set_error_po_total] = useState<boolean>(false);

    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [existe_cabecalho, set_existe_cabecalho] = useState(false)
    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);



    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
        set_flag_editado(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo(aux_obj_anexo);

        } else {
            if (name === 'ko_total') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_ko_total(true)
                } else {
                    set_error_ko_total(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            }
            if (name === 'numero') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_numero(true)
                } else {
                    set_error_numero(false)
                    if (obj_anexo?.valor_ref_n !== undefined) {
                        let aux_numero_total = value * Number(obj_anexo?.valor_ref_n)
                        set_obj_anexo((old: any) => ({
                            ...old,
                            'numero_total': aux_numero_total,
                        }));
                    }
                    if (obj_anexo?.valor_ref_po !== undefined) {
                        let aux_po_total = value * Number(obj_anexo?.valor_ref_po)
                        set_obj_anexo((old: any) => ({
                            ...old,
                            'po_total': aux_po_total,
                        }));
                    }
                    if (obj_anexo?.valor_ref_ko !== undefined) {
                        let aux_ko_total = value * Number(obj_anexo?.valor_ref_ko)
                        set_obj_anexo((old: any) => ({
                            ...old,
                            'ko_total': aux_ko_total,
                        }));
                    }

                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'valor_ref_n') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_valor_ref_n(true)
                } else {
                    set_error_valor_ref_n(false)
                    if (obj_anexo?.numero !== undefined) {
                        let aux_numero_total = value * Number(obj_anexo?.numero)
                        set_obj_anexo((old: any) => ({
                            ...old,
                            'numero_total': aux_numero_total,
                        }));
                    }

                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'valor_ref_po') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_valor_ref_po(true)
                } else {
                    set_error_valor_ref_po(false)
                    if (obj_anexo?.numero !== undefined) {
                        let aux_po_total = value * Number(obj_anexo?.numero)
                        set_obj_anexo((old: any) => ({
                            ...old,
                            'po_total': aux_po_total,
                        }));
                    }
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'valor_ref_ko') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_valor_ref_ko(true)
                } else {
                    set_error_valor_ref_ko(false)
                    if (obj_anexo?.numero !== undefined) {
                        let aux_ko_total = value * Number(obj_anexo?.numero)
                        set_obj_anexo((old: any) => ({
                            ...old,
                            'ko_total': aux_ko_total,
                        }));
                    }
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'numero_total') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_numero_total(true)
                } else {
                    set_error_numero_total(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'po_total') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_po_total(true)
                } else {
                    set_error_po_total(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }

        }


    };
    const handle_criar_anexo = async () => {
        if (error_po_total || error_ko_total || error_numero || error_valor_ref_n || error_valor_ref_po || error_valor_ref_ko || error_numero_total || error_ko_total) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);


                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_sete", {
                    payload: {

                        id_nutrientes: 0,
                        especie: obj_anexo?.especie === undefined ? '' : obj_anexo?.especie,
                        numero: obj_anexo?.numero === undefined ? '' : obj_anexo?.numero.toString(),
                        valor_ref_n: obj_anexo?.valor_ref_n === undefined ? '' : obj_anexo?.valor_ref_n.toString(),
                        valor_ref_po: obj_anexo?.valor_ref_po === undefined ? '' : obj_anexo?.valor_ref_po.toString(),
                        valor_ref_ko: obj_anexo?.valor_ref_ko === undefined ? '' : obj_anexo?.valor_ref_ko.toString(),
                        numero_total: obj_anexo?.numero_total === undefined ? '' : obj_anexo?.numero_total.toString(),
                        po_total: obj_anexo?.po_total === undefined ? '' : obj_anexo?.po_total.toString(),
                        ko_total: obj_anexo?.ko_total === undefined ? '' : obj_anexo?.ko_total.toString(),
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    set_obj_anexo(undefined)
                    set_flag_editado(false)

                    setCreateTable(false)
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista((old) => [...old, data.data.result[0]])
                    set_obj_da_tabela_3_atualizado(data.data.result[1])

                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }

    const handle_update_anexo = async () => {
        if (error_ko_total || error_numero || error_valor_ref_n || error_valor_ref_po || error_valor_ref_ko || error_numero_total || error_ko_total) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {
            try {
                setIsLoading(true);

                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_sete", {
                    payload: {

                        id_nutrientes: obj_anexo?.id_nutrientes === undefined ? '' : obj_anexo?.id_nutrientes,
                        especie: obj_anexo?.especie === undefined ? '' : obj_anexo?.especie,
                        numero: obj_anexo?.numero === undefined || obj_anexo?.numero === null ? '' : obj_anexo?.numero.toString(),
                        valor_ref_n: obj_anexo?.valor_ref_n === undefined || obj_anexo?.valor_ref_n === null ? '' : obj_anexo?.valor_ref_n.toString(),
                        valor_ref_po: obj_anexo?.valor_ref_po === undefined || obj_anexo?.valor_ref_po === null ? '' : obj_anexo?.valor_ref_po.toString(),
                        valor_ref_ko: obj_anexo?.valor_ref_ko === undefined || obj_anexo?.valor_ref_ko === null ? '' : obj_anexo?.valor_ref_ko.toString(),
                        numero_total: obj_anexo?.numero_total === undefined || obj_anexo?.numero_total === null ? '' : obj_anexo?.numero_total.toString(),
                        po_total: obj_anexo?.po_total === undefined || obj_anexo?.po_total === null ? '' : obj_anexo?.po_total.toString(),
                        ko_total: obj_anexo?.ko_total === undefined || obj_anexo?.ko_total === null ? '' : obj_anexo?.ko_total.toString(),

                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                });

                if (res.status === 200) {
                    let lista_aux: any = obj_anexo_lista?.map((el) => {
                        if (el.id_nutrientes !== obj_anexo?.id_nutrientes) {
                            return el
                        } else {
                            return res.data.result[0]
                        }
                    })
                    set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                    set_obj_anexo(undefined);
                    set_obj_da_tabela_3_atualizado(res.data.result[1])
                    setCreateTable(false)
                    set_flag_editado(false)

                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!2");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    };
    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, "delete__reg_anexo_um_sete", {
                payload: {

                    id_nutrientes: obj_anexo?.id_nutrientes === undefined ? '' : obj_anexo?.id_nutrientes,
                    especie: obj_anexo?.especie === undefined ? '' : obj_anexo?.especie,
                    numero: obj_anexo?.numero === undefined ? '' : obj_anexo?.numero.toString(),
                    valor_ref_n: obj_anexo?.valor_ref_n === undefined ? '' : obj_anexo?.valor_ref_n.toString(),
                    valor_ref_po: obj_anexo?.valor_ref_po === undefined ? '' : obj_anexo?.valor_ref_po.toString(),
                    valor_ref_ko: obj_anexo?.valor_ref_ko === undefined ? '' : obj_anexo?.valor_ref_ko.toString(),
                    numero_total: obj_anexo?.numero_total === undefined ? '' : obj_anexo?.numero_total.toString(),
                    po_total: obj_anexo?.po_total === undefined ? '' : obj_anexo?.po_total.toString(),
                    ko_total: obj_anexo?.ko_total === undefined ? '' : obj_anexo?.ko_total.toString(),
                    id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: ""
                }
            });
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.filter((el) => {
                    if (el.id_nutrientes !== obj_anexo?.id_nutrientes) {
                        return el
                    }
                })
                set_obj_da_tabela_3_atualizado(res.data.result)

                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    setCreateTable(true)
                }
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };


    const handleCloseSnack = () => {
        setOpenSnackError(false)
        setOpenSnackSuccess(false);
    };



    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - obj_anexo_lista?.length) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_sete_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );

            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_anexo_lista(res.data.result);
                } else {
                    setCreateTable(true)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };
    const handleCloseDialog = () => {
        set_obj_anexo(undefined)
        setCreateTable(false)

        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();
                set_existe_cabecalho(true)

            } else {
                set_existe_cabecalho(false)
                set_obj_anexo_lista([]);


            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    return (
        <>
            <TableContainer
                component={Paper}
                variant="outlined"
                sx={{
                    height: "auto",
                    width: "auto",
                    margin: 2,
                    padding: 2,
                }}
            >
                <Snackbar
                    open={openSnackSuccess}
                    autoHideDuration={2000}
                    onClose={handleCloseSnack}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="success"
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openSnackError}
                    autoHideDuration={2000}
                    onClose={handleCloseSnack}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="error"
                        sx={{ width: "100%" }}
                    >
                        {message}

                    </Alert>
                </Snackbar>
                <table style={{ width: "100%" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                colSpan={8}
                                sx={{
                                    fontWeight: 600,
                                    fontFamily: "candara",
                                    fontSize: 16,
                                }}
                            >
                                1.7 - Nutrientes principais provenientes do excreta dos animais
                                em pastoreio
                                <BasicPopover
                                    text={
                                        "O beneficiário deve preencher este campo no caso das pastagens que são objeto de pastoreio direto."
                                    }
                                />
                            </TableCell>
                            <TableCell>
                                {

                                    existe_cabecalho === false ? <></> :
                                        <Stack direction="row" justifyContent="end">
                                            {is_historico === true ? <></> :

                                                <BarraDeFerramentas
                                                    mostrarBotaoNovo
                                                    textoBotaoNovo="Novo Registo"
                                                    aoClicarNovo={() => {
                                                        set_obj_anexo(undefined)

                                                        setCreateTable(true)
                                                    }}
                                                />}
                                        </Stack>
                                }

                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    Espécie pecuária
                                    <BasicPopover
                                        text={
                                            "Identificar a espécie pecuária que pastoreia anualmente a pastagem a que diz respeito o presente plano de fertilização.\n\nDeverão ser acrescentadas linhas ao presente quadro, no caso de não serem suficientes para registar o contributo do excreta do efetivo pecuário que pastoreia a pastagem."
                                        }
                                    />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    N.º CN/ha
                                    <BasicPopover text="Registar o n.º CN (cabeças normais) que pastoreiam anualmente a pastagem" />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    Valor de referência N
                                    <BasicPopover text="Preencher de acordo com os valores de referência constantes no Anexo VI do Código das Boas Práticas Agrícolas." />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    Valor de referência P2O5
                                    <BasicPopover text="Preencher de acordo com os valores de referência constantes no Anexo VI do Código das Boas Práticas Agrícolas." />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    Valor de referência K2O
                                    <BasicPopover text="Preencher de acordo com os valores de referência constantes no Anexo VI do Código das Boas Práticas Agrícolas." />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    N total por espécie/há
                                    <BasicPopover
                                        text={
                                            "Preencher com o resultado do produto do valor de referência para o Nx pelo n.º de CN.\n\nN total/espécie= N.ºCN/ha x Valor ref N"
                                        }
                                    />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    P2O5 total por espécie
                                    <BasicPopover
                                        text={
                                            "Preencher com o resultado do produto do valor de referência para o P2O5x pelo n.º de CN.\n\nP2O5 total/espécie= N.ºCN/ha x Valor ref P2O5"
                                        }
                                    />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead sx={{ minWidth: 100 }}>
                                <Stack direction="row">
                                    K2O total por espécie/ha
                                    <BasicPopover
                                        text={
                                            "Preencher com o resultado do produto do valor de referência para o K2Ox pelo n.º de CN.\n\nK2O total/espécie= N.ºCN/ha x Valor ref K2O"
                                        }
                                    />
                                </Stack>
                            </StyledTableHead>
                            <StyledTableHead>Ações</StyledTableHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createTable && (
                            <>
                                <TableRow>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="especie"
                                            value={obj_anexo?.especie === undefined ? '' : obj_anexo?.especie}
                                            onChange={onInputChange}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="numero"
                                            value={obj_anexo?.numero === undefined ? '' : obj_anexo?.numero.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_numero}
                                            helperText={error_numero ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="valor_ref_n"
                                            value={obj_anexo?.valor_ref_n === undefined ? '' : obj_anexo?.valor_ref_n.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_valor_ref_n}
                                            helperText={error_valor_ref_n ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="valor_ref_po"
                                            value={obj_anexo?.valor_ref_po === undefined ? '' : obj_anexo?.valor_ref_po.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_valor_ref_po}
                                            helperText={error_valor_ref_po ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="valor_ref_ko"
                                            value={obj_anexo?.valor_ref_ko === undefined ? '' : obj_anexo?.valor_ref_ko.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_valor_ref_ko}
                                            helperText={error_valor_ref_ko ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        {obj_anexo?.numero_total === undefined ? '' : obj_anexo?.numero_total.toString().replace('.', ',')}

                                    </StyledTableHead>
                                    <StyledTableHead>
                                        {obj_anexo?.po_total === undefined ? '' : obj_anexo?.po_total.toString().replace('.', ',')}

                                    </StyledTableHead>
                                    <StyledTableHead>
                                        {obj_anexo?.ko_total === undefined ? '' : obj_anexo?.ko_total.toString().replace('.', ',')}

                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <ButtonCadernos
                                            mostrarBotaoCancelar
                                            aoClicarCancelar={() => {
                                                if (flag_editado) {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                } else {
                                                    set_obj_anexo(undefined)
                                                    setCreateTable(false)
                                                }

                                            }}
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => { handle_criar_anexo() }}
                                        />
                                    </StyledTableHead>
                                </TableRow>
                            </>
                        )}

                        {(rowsPerPage > 0
                            ? obj_anexo_lista?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : obj_anexo_lista
                        ).map((row) => {
                            if (obj_anexo?.id_nutrientes === row.id_nutrientes) {
                                return (
                                    <TableRow>

                                        <StyledTableCell>
                                            <CustomTextField
                                                name="especie"
                                                value={obj_anexo?.especie === undefined || obj_anexo.especie === null ? '' : obj_anexo?.especie}
                                                onChange={onInputChange}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="numero"
                                                value={obj_anexo?.numero === undefined || obj_anexo.numero === null ? '' : obj_anexo?.numero.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_numero}
                                                helperText={error_numero ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="valor_ref_n"
                                                value={obj_anexo?.valor_ref_n === undefined || obj_anexo.valor_ref_n === null ? '' : obj_anexo?.valor_ref_n.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_valor_ref_n}
                                                helperText={error_valor_ref_n ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="valor_ref_po"
                                                value={obj_anexo?.valor_ref_po === undefined || obj_anexo.valor_ref_po === null ? '' : obj_anexo?.valor_ref_po.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_valor_ref_po}
                                                helperText={error_valor_ref_po ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="valor_ref_ko"
                                                value={obj_anexo?.valor_ref_ko === undefined || obj_anexo.valor_ref_ko === null ? '' : obj_anexo?.valor_ref_ko.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_valor_ref_ko}
                                                helperText={error_valor_ref_ko ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {obj_anexo?.numero_total === undefined || obj_anexo.numero_total === null ? '' : obj_anexo?.numero_total.toString().replace('.', ',')}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {obj_anexo?.po_total === undefined || obj_anexo.po_total === null ? '' : obj_anexo?.po_total.toString().replace('.', ',')}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {obj_anexo?.ko_total === undefined || obj_anexo.ko_total === null ? '' : obj_anexo?.ko_total.toString().replace('.', ',')}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <ButtonCadernos
                                                mostrarBotaoCancelar
                                                aoClicarCancelar={() => {
                                                    if (flag_editado) {
                                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                    } else {
                                                        set_obj_anexo(undefined)
                                                        setCreateTable(false)
                                                    }
                                                }}
                                                mostrarBotaoGravar
                                                aoClicarGravar={() => { handle_update_anexo() }}
                                            />
                                        </StyledTableCell>


                                    </TableRow>
                                )
                            } else {
                                return (
                                    <TableRow>

                                        <StyledTableCell>{row.especie === undefined || row.especie === null ? '' : row.especie}</StyledTableCell>
                                        <StyledTableCell>{row.numero === undefined || row.numero === null ? '' : row.numero.toString().replace('.', ',')}</StyledTableCell>
                                        <StyledTableCell>{row.valor_ref_n === undefined || row.valor_ref_n === null ? '' : row.valor_ref_n.toString().replace('.', ',')}</StyledTableCell>
                                        <StyledTableCell>{row.valor_ref_po === undefined || row.valor_ref_po === null ? '' : row.valor_ref_po.toString().replace('.', ',')}</StyledTableCell>
                                        <StyledTableCell>{row.valor_ref_ko === undefined || row.valor_ref_ko === null ? '' : row.valor_ref_ko.toString().replace('.', ',')}</StyledTableCell>
                                        <StyledTableCell>{row.numero_total === undefined || row.numero_total === null ? '' : row.numero_total.toString().replace('.', ',')}</StyledTableCell>
                                        <StyledTableCell>{row.po_total === undefined || row.po_total === null ? '' : row.po_total.toString().replace('.', ',')}</StyledTableCell>
                                        <StyledTableCell>{row.ko_total === undefined || row.ko_total === null ? '' : row.ko_total.toString().replace('.', ',')}</StyledTableCell>

                                        <StyledTableCell>
                                            {is_historico === true ? <></> :

                                                <ButtonCadernos
                                                    mostrarBotaoEditar
                                                    aoClicarEditar={() => {
                                                        setCreateTable(false)
                                                        set_obj_anexo(row)
                                                    }}
                                                    mostrarBotaoApagar
                                                    aoClicarApagar={() => {

                                                        set_obj_anexo(row)
                                                        set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                    }}
                                                />}
                                        </StyledTableCell>

                                    </TableRow>
                                )
                            }

                        }


                        )}
                        <TableRow>
                            <StyledTableHead colSpan={5} sx={{ textAlign: "right" }}>
                                Total (kg/ha):
                                <BasicPopover
                                    text={
                                        "Preencher com o resultado da soma dos valores registados nas colunas «N total por espécie», «P2O5 total por espécie» e «K2O total por espécie»."
                                    }
                                />
                            </StyledTableHead>
                            <StyledTableCell>{sum_column_from_array('numero_total', obj_anexo_lista)}</StyledTableCell>
                            <StyledTableCell>{sum_column_from_array('po_total', obj_anexo_lista)}</StyledTableCell>

                            <StyledTableCell>{sum_column_from_array('ko_total', obj_anexo_lista)}</StyledTableCell>
                        </TableRow>
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={19} />
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow sx={{ width: "100%" }}>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                colSpan={14}
                                count={obj_anexo_lista?.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                labelDisplayedRows={({ from, to, count }) => {
                                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                                }}
                                labelRowsPerPage={'Linhas por página'}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                </table>
                <ConfirmDialog
                    open={open_dialog_tem_a_certeza_que_quer_eliminar}
                    onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                    onConfirm={handle_delete_anexo}
                    message="Deseja eliminar o registo?"
                />
                <ConfirmDialog
                    open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                    onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                    onConfirm={() => handleCloseDialog()}
                    message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                />
            </TableContainer>
        </>
    );
};